'use client';

import * as React from 'react';
import { applyAppTheme, loadAppTheme, subscribeAppTheme } from './appTheme';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  React.useEffect(() => {
    applyAppTheme(loadAppTheme());
    return subscribeAppTheme(() => applyAppTheme(loadAppTheme()));
  }, []);

  return children;
}
